import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-12 mt-12">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Блок "О нас" */}
        <div>
          <h3 className="text-lg font-semibold mb-4">О нас</h3>
          <p className="text-sm text-gray-300 mb-4">
            Мы предлагаем профессиональные консультации и быструю обратную связь. Ваш комфорт — наш приоритет.
          </p>
          <a href="/about" className="text-red-500 hover:underline">Узнать больше</a>
        </div>

        {/* Блок "Каталог" */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Каталог</h3>
          <ul className="text-sm text-gray-300 space-y-2">
            <li><a href="/catalog" className="hover:text-red-500 hover:underline">Посмотреть каталог</a></li>
          </ul>
        </div>

        {/* Блок "Контакты" */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Контакты</h3>
          <ul className="text-sm text-gray-300 space-y-2">
            <li>Телефон: <a href="tel:+7 (967)160-22-66" className="hover:text-red-500">+7 (967) 160-22-66</a></li>
            <li>Email: <a href="mailto:serejazork@gmail.com" className="hover:text-red-500">serejazork@gmail.com</a></li>
            <li>Адрес: Центральная ул., 15А, стр. 4</li>
          </ul>
        </div>
      </div>

      {/* Блок "Полезные ссылки" */}
      <div className="mt-8 pt-4 text-center">
        <a href="/privacy" className="text-sm text-gray-400 hover:text-red-500 hover:underline">Политика конфиденциальности</a>
      </div>

      {/* Низ подвала */}
      <div className="mt-12 pt-6 text-center text-sm text-gray-400">
        <p>© {new Date().getFullYear()} Все права защищены.</p>
        <p>Разработано с любовью для вас.</p>
      </div>
    </footer>
  );
}
